import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function DownloadIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="DownloadIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                id="Trazado_1822"
                d="M194.692,676a.962.962,0,0,1,.962.962V687.14l2.2-2.2a.961.961,0,0,1,1.36,1.36l-3.846,3.846a.96.96,0,0,1-1.36,0l-3.846-3.846a.961.961,0,0,1,1.36-1.36l2.2,2.2V676.962A.962.962,0,0,1,194.692,676Zm-6.731,14.423a.962.962,0,0,1,.962.962v1.923h11.538v-1.923a.962.962,0,1,1,1.923,0v1.923a1.923,1.923,0,0,1-1.923,1.923H188.923A1.923,1.923,0,0,1,187,693.308v-1.923A.962.962,0,0,1,187.962,690.423Z"
                transform="translate(-187 -676)"
                fill="#e6ba0e"
            />
        </SvgIcon>
    );
}
